import * as numeral from 'numeral';

export class MeasureInputValueConverter {
    toView(value: any, allowDecimals: boolean) {
        if (value === null || value === undefined) {
            return '';
        }

        if(isNaN(value)) {
            return value;
        }

        let decimalFormat = ''; 
        if(allowDecimals) {
            decimalFormat = '[.][0000000000]'
        }
        
		return numeral(value).format('0,0' + decimalFormat);
    }
}